<template>
	<div class="user flex main other_main">
		<asiden :asideData="asideList"></asiden>
		<div class="main_r">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import asiden from "../layout/aside/aside.vue";
export default {
	components: { asiden },
	name: "",
	data() {
		return {
			asideList: [
				{
					title: "推送信息",
					icon: "",
					router: "/information/push",
					permissions: 701,
				},
				{
					title: "新增推送信息",
					icon: "",
					router: "/information/addPush",
					permissions: 704,
				},
				{
					title: "问题反馈",
					icon: "",
					router: "/information/problemfeedback",
					permissions: 702,
				},
				{
					title: "举报信息",
					icon: "",
					router: "/information/reportinfo",
					permissions: 703,
				},
				{
					title: "Telegram推送",
					icon: "",
					router: "/information/telegram",
					permissions: 705,
				},
			],
		};
	},
	mounted() {
		const role_permissions = this.$store.state.user.user.role_permissions; // 假设格式是 "100,200,300"
		if (role_permissions) {
			const permissionArray = role_permissions.split(",").map(Number); // 转换为数字数组
			this.asideList = this.asideList.filter((item) =>
				permissionArray.includes(item.permissions)
			);
		}
	},
};
</script>

<style scoped></style>
